import PartnerRoleList from './role.vue'
export default PartnerRoleList
